import { useState } from 'react'
import { startGoogleLogin } from '../lib/oauth'

export function Login() {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const onSignIn = async () => {
    setBusy(true)
    setError(null)
    try {
      await startGoogleLogin({
        clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID as string,
        redirectUri: `${window.location.origin}/auth/callback`,
      })
    } catch (e) {
      setBusy(false)
      setError(e instanceof Error ? e.message : 'Login failed')
    }
  }

  return (
    <div className="mx-auto max-w-md px-6 py-24">
      <h1 className="text-2xl font-semibold tracking-tight">登录到 OnlyBans</h1>
      <p className="mt-2 text-sm text-zinc-400">
        使用 Google 账号登录。第一次登录会自动创建账号。
      </p>

      <button
        onClick={onSignIn}
        disabled={busy}
        className="mt-8 inline-flex w-full items-center justify-center gap-3 rounded-md bg-zinc-100 px-4 py-3 text-sm font-medium text-zinc-900 hover:bg-white disabled:opacity-60"
      >
        <GoogleIcon className="h-4 w-4" />
        {busy ? '正在跳转 Google…' : 'Sign in with Google'}
      </button>

      {error ? (
        <p className="mt-4 text-sm text-red-400">{error}</p>
      ) : null}

      <p className="mt-8 text-xs text-zinc-500">
        登录即表示同意我们的{' '}
        <a href="/terms" className="underline hover:text-zinc-300">服务条款</a>
        {' '}和{' '}
        <a href="/privacy" className="underline hover:text-zinc-300">隐私政策</a>
        。
      </p>
    </div>
  )
}

function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path
        fill="#4285F4"
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      />
      <path
        fill="#FBBC05"
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
      />
      <path
        fill="#EA4335"
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"
      />
    </svg>
  )
}
